









































































import Vue, { PropType } from "vue";
import NumberText from "@/components/Atoms/Typography/Number/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    NumberText
  },
  props: {
    isShowTimeline: {
      type: Boolean,
      default: true
    },
    graduateYear: {
      type: Number,
      default: undefined
    },
    timelineHeight: {
      type: Number,
      default: -1
    },
    isYearVisible: {
      type: Boolean,
      default: false
    },
    sectionMinWidth: {
      type: Number,
      required: true
    },
    scrollArea: {
      type: String as PropType<Props["scrollArea"]>,
      required: true
    },
    axisHeight: {
      type: Number,
      default: undefined
    },
    isExtraTimeline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scrollRightPaddingWidth: 20,
      scaleHeight: "100%"
    };
  },
  computed: {
    times() {
      const START_MONTH = 4;
      const MONTHS_COUNT = 12;
      const TIMEBOX_COUNT = 17;
      return Array.from(new Array(TIMEBOX_COUNT)).map((v, i) => {
        const time = (i + (START_MONTH + 1)) % MONTHS_COUNT;
        return time === 0 ? MONTHS_COUNT : time;
      });
    },
    timelineMinWidth() {
      return `${this.times.length * this.sectionMinWidth}px`;
    }
  },
  watch: {
    timelineHeight: {
      immediate: true,
      deep: true,
      handler() {
        // NOTE 描画されるのを待って処理する
        this.$nextTick(() => {
          this.scaleHeight = this.calcScaleHeight();
        });
      }
    }
  },
  methods: {
    timeClass(time: string) {
      const timeClass: { [key: string]: boolean } = {};
      timeClass[`month${time}`] = true;
      return timeClass;
    },
    handleScrollAxisArea(event) {
      this.$emit("syncedScroll", {
        scrollArea: this.scrollArea + "_AXIS",
        event
      });

      if (!event.target || !(event.target instanceof Element)) return;
    },
    handleScrollSectionArea(event) {
      this.$emit("syncedScroll", {
        scrollArea: this.scrollArea,
        event
      });

      if (!event.target || !(event.target instanceof Element)) return;
    },
    calcScaleHeight() {
      const defaultHeight = "100%";
      if (this.timelineHeight < 0) {
        return defaultHeight;
      }
      const $timeline = this.$el.getElementsByClassName(
        "eventTimeline__timeline"
      )[0] as Element;
      if (!$timeline) {
        return defaultHeight;
      }
      const hasVerticalScroll = $timeline.clientHeight < this.timelineHeight;
      return hasVerticalScroll ? `${this.timelineHeight}px` : defaultHeight;
    }
  }
});
